import * as SentryImport from '@sentry/vue'

// TODO: report issue to the Nuxt team, on prod SSR in wrapped into default export

export const Sentry: typeof SentryImport =
  process.env.NODE_ENV === 'production' && process.server // @ts-expect-error builder issue fix
    ? SentryImport.default // eslint-disable-line import/namespace
    : SentryImport
